<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <div class="flex flex_warp">
        <el-date-picker v-model="timeArr" type="daterange" range-separator="至" start-placeholder="开始日期"
          class="mr20 mb10" end-placeholder="结束日期">
        </el-date-picker>
        <el-button type="primary" class="mb10" @click="search">搜索</el-button>
      </div>


      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="收支报表" name="1" v-if="role.includes('v1.window.statement.income')">
          <statement_income :endTime="endTime" ref="statement_income" :startTime="startTime"></statement_income>
        </el-tab-pane>
        <el-tab-pane label="票务报表" name="2" v-if="role.includes('v1.window.statement.ticket')">
          <statement_ticket :endTime="endTime" ref="statement_ticket" :startTime="startTime"></statement_ticket>
        </el-tab-pane>
        <el-tab-pane label="年卡报表" name="3" v-if="role.includes('v1.window.statement.yearCard')">
          <statement_yearCard :endTime="endTime" ref="statement_yearCard" :startTime="startTime"></statement_yearCard>
        </el-tab-pane>
      </el-tabs>




    </div>

  </div>
</template>
<script>

import { parseTime } from "@/utils/index"
import statement_income from './compoenets/statement_income'
import statement_ticket from './compoenets/statement_ticket'
import statement_yearCard from './compoenets/statement_yearCard'
export default {
  data() {
    return {
      activeName: '1',
      startTime: '',
      endTime: '',
      timeArr:[]
    };
  },
  components: {
    statement_income, statement_ticket, statement_yearCard
  },
  watch: {},
  methods: {
    addNew() {
      this.handleId = '';
      this.val = '';
      this.dialogVisible = true
    },
    handleClick(tab, event) {
      this.$nextTick(_ => {
        if (this.activeName == 1) {
          this.$refs.statement_income.resetData()
        } else if (this.activeName == 2) {
          this.$refs.statement_ticket.resetData()
        } else {
          this.$refs.statement_yearCard.resetData()
        }
      })
    },
    handleSelectionChange(e) {
      this.choseArr = e;
    },
    search() {
      this.startTime = parseTime(this.timeArr[0], '{y}-{m}-{d}');
      this.endTime = parseTime(this.timeArr[1], '{y}-{m}-{d}');
      this.$nextTick(r => {
        if (this.activeName == 1) {
          this.$refs.statement_income.resetData()
        } else if (this.activeName == 2) {
          this.$refs.statement_ticket.resetData()
        } else {
          this.$refs.statement_yearCard.resetData()
        }
      })
    },
    get_yearCard_list() {
      this.api.postUrl('/api/v1/window/statement/yearCard', { startTime: this.startTime, endTime: this.endTime }, { loading: true }).then(res => {

      })
    },
  },
  created() {
    this.role = this.$store.getters.roles ? this.$store.getters.roles : [];
    this.timeArr = [new Date(), new Date()];
    this.startTime = parseTime(new Date(), '{y}-{m}-{d}');
    this.endTime = parseTime(new Date(), '{y}-{m}-{d}');
    this.$nextTick(_ => {
      if (this.role.includes('v1.window.statement.income')) {
        this.activeName = '1'
        this.$refs.statement_income.resetData()
      } else if (this.role.includes('v1.window.statement.ticket')) {
        this.activeName = '2'
        this.$refs.statement_ticket.resetData()
      } else {
        this.activeName = '3'
        this.$refs.statement_yearCard.resetData()

      }
    })
  },
};
</script>
<style scoped>
.list-items {
  width: 266px;
  height: 150px;
  background: #F5F7FA;
  border-radius: 8px 8px 8px 8px;
  box-sizing: border-box;
}

.icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
}

.page_title {
  margin-bottom: 24px;
}

.label.label1 {
  color: #67C23A;
  background: rgba(103, 194, 58, .29);
}

.label {
  padding: 2px 6px;
  background: rgba(64, 158, 255, .29);
  border-radius: 4px;
}

.t-btn {
  margin-right: 40px;
  position: relative;
}

.t-btn.main_color::after {
  position: absolute;
  bottom: -18px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #409EFF;
  content: " ";
}

.s-icon {
  border-radius: 4px 4px 4px 4px;
  padding: 2px 7px;
}

.s-icon1 {
  background: rgba(64, 158, 255, .29);
  color: rgba(64, 158, 255, 1);
}

.s-icon2 {
  background: rgba(245, 108, 108, .29);
  color: rgba(245, 108, 108, 1);
}

.s-input {
  width: 200px;
}
</style>
<style>
.el-progress__text {
  font-size: 13px !important;
}
</style>